'use client';

import Link from 'next/link';

export function Footer() {
  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div>
          <p className="footer-company">Bitcoin Pizza Chart</p>
          <p className="muted small">Educational BTC purchasing-power visualization.</p>
        </div>

        <nav aria-label="Legal links" className="footer-links">
          <Link href="/privacy">Privacy</Link>
          <Link href="/cookies">Cookies</Link>
          <Link href="/terms">Terms</Link>
          <Link href="/disclaimer">Disclaimer</Link>
          <Link href="/contact">Contact</Link>
          <Link href="/imprint">Imprint</Link>
          <button
            type="button"
            className="footer-manage"
            onClick={() => {
              if (typeof window !== 'undefined' && typeof (window as any).__bpzOpenConsent === 'function') {
                (window as any).__bpzOpenConsent();
              }
            }}
          >
            Manage cookies
          </button>
        </nav>
      </div>
    </footer>
  );
}
